package uk.co.nickthecoder.glok.backend.webgl

import org.khronos.webgl.WebGLRenderingContext.Companion.TRIANGLE_STRIP
import uk.co.nickthecoder.glok.backend.Vector2
import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.glok.util.Matrix

internal class FlatColorProgram : SimpleProgram(vertex, fragment) {

    private val colorLocation = getUniformLocation("color")

    private fun begin(viewMatrix: Matrix, color: Color) {
        begin(viewMatrix)
        setUniform(colorLocation, color)
    }

    fun drawLine(from: Vector2, to: Vector2, thickness: Float) {
        val delta = (to - from).unit().perpendicular() * (thickness / 2f)

        drawTriangles(
            arrayOf<Float>(

                from.x + delta.x, from.y + delta.y,
                from.x - delta.x, from.y - delta.y,
                to.x + delta.x, to.y + delta.y,

                to.x + delta.x, to.y + delta.y,
                to.x - delta.x, to.y - delta.y,
                from.x - delta.x, from.y - delta.y
            )
        )
    }

    fun strokeInsideRect(
        left: Float, top: Float, right: Float, bottom: Float,
        insideLeft: Float, insideTop: Float, insideRight: Float, insideBottom: Float
    ) {
        // log.info("strokeInsideRect ($left,$top)->($right,$bottom) : ($insideLeft,$insideTop)->($insideRight,$insideBottom)")

        drawTriangles(
            arrayOf<Float>(
                insideLeft, insideTop,
                left, top,
                insideRight, insideTop,
                right, top,
                insideRight, insideBottom,
                right, bottom,
                insideLeft, insideBottom,
                left, bottom,
                insideLeft, insideTop,
                left, top
            ), TRIANGLE_STRIP
        )
    }


    fun fillRect(left: Float, top: Float, right: Float, bottom: Float) {
        // log.info("fillRect ($left,$top)->($right,$bottom)")

        drawTriangles(
            arrayOf<Float>(
                left, bottom,
                right, bottom,
                left, top,
                right, top
            ), TRIANGLE_STRIP
        )
    }

    companion object {
        private val instance = FlatColorProgram()

        fun use(viewMatrix: Matrix, color: Color, block: FlatColorProgram.() -> Unit) {
            instance.begin(viewMatrix, color)
            instance.block()
            instance.end()
        }
    }
}

private const val vertex = """
attribute vec2 position;

uniform mat3 viewMatrix;

void main() {
    gl_Position = vec4( viewMatrix * vec3(position, 1.0), 1.0);
}
"""

private const val fragment = """
precision highp float;
            
uniform vec4 color;

void main() {
    gl_FragColor = color;
}
"""
